// extracted by mini-css-extract-plugin
export var active = "_b7-7";
export var container = "_b7-0";
export var evenWidth = "_b7-4";
export var large = "_b7-5";
export var outlet = "_b7-8";
export var slide = "_b7-2";
export var small = "_b7-6";
export var tab = "_b7-3";
export var tabs = "_b7-1";